export default function onDOMContentLoaded(callback) {
    document.addEventListener("DOMContentLoaded", callback)
}
